import * as model from './model.js';
import { MODAL_CLOSE_SECONDS } from './config.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import uploadView from './views/uploadView.js';

import 'core-js/actual';
import 'regenerator-runtime/runtime';

// PARCEL SAVE STATE

// if (module.hot) {
//   module.hot.accept();
// }

const controlRecipes = async function () {
  try {
    const recipeID = window.location.hash.slice(1);
    if (!recipeID) return;

    recipeView.renderSpinner();
    resultsView.updateContent(model.getSearchResultsPage());
    bookmarksView.updateContent(model.state.bookmarks);
    await model.loadRecipe(recipeID);
    recipeView.renderContent(model.state.recipe);
  } catch (error) {
    console.error(error);
  }
};

const controlSearchResults = async function () {
  try {
    const query = searchView.getQuery();
    if (!query) return;

    resultsView.renderSpinner();
    await model.loadSearchResults(query);
    resultsView.renderContent(model.getSearchResultsPage(1));
    paginationView.renderContent(model.state.search);
  } catch (error) {
    console.error(error);
  }
};

const controlPagination = function (navigatePage) {
  resultsView.renderContent(model.getSearchResultsPage(navigatePage));
  paginationView.renderContent(model.state.search);
};

const controlServings = function (adjustedServings) {
  model.updateServings(adjustedServings);
  recipeView.updateContent(model.state.recipe);
};

const controlBookmark = function () {
  if (!model.state.recipe.bookmarked) {
    model.addBookmark(model.state.recipe);
  } else if (model.state.recipe.bookmarked) {
    model.removeBookmark(model.state.recipe);
  }
  recipeView.updateContent(model.state.recipe);
  bookmarksView.renderContent(model.state.bookmarks);
};

const controlInitialBookmarks = function () {
  bookmarksView.renderContent(model.state.bookmarks);
};

const controlUpload = async function (newRecipe) {
  try {
    uploadView.renderSpinner();
    await model.uploadRecipe(newRecipe);
    recipeView.renderContent(model.state.recipe);
    uploadView.renderMessage();
    window.history.pushState(null, '', `#${model.state.recipe.id}`);
    bookmarksView.renderContent(model.state.bookmarks);
    setTimeout(() => uploadView.toggleWindow(), MODAL_CLOSE_SECONDS * 1000);
  } catch (error) {
    console.error(error);
    uploadView.renderError(error);
  }
};

(function init() {
  bookmarksView.addHandlerRenderBookmarks(controlInitialBookmarks);
  recipeView.addHandlerRenderRecipe(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerBookmark(controlBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerPagination(controlPagination);
  uploadView.addHandlerUploadRecipe(controlUpload);
})();
